import { createFileRoute, Outlet } from '@tanstack/react-router'

// Parent of the run workspace (index) and its read-only preview.
export const Route = createFileRoute('/poc/recipe-generator/$runId')({
  component: Outlet
})
